module.exports = __webpack_public_path__ + "img/gelb0.c80c7abf.png";